import axios from 'axios'
import { TokenService } from '../services/storage.service'



const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },



    setHeader() {
        // console.log(TokenService.getToken());
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + TokenService.getToken()
        //  axios.defaults.headers.common["Authorization"] = TokenService.getRefreshToken()
        axios.defaults.headers.common["Content-Type"] = 'application/json'


    },
    setMultiPartHeader() {
        // console.log(TokenService.getToken());
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + TokenService.getToken()
        //  axios.defaults.headers.common["Authorization"] = TokenService.getRefreshToken()
        axios.defaults.headers.common["Content-Type"] = 'multipart/form-data'


    },


    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        return axios.get(resource)
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {

        return axios(data)


    }
}

export default ApiService